import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import classnames from 'classnames';
import { getServerPools} from "../../../actions/actionServerPool";
import { Row, Col, Table, Card, CardBody, CardHeader, Button, TabContent, TabPane, Nav, NavItem, NavLink} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home", path:"/userdashboard", isActive: false},
    {name: "ServerPool", path:"/server_pools", isActive: false},
    {name: "ViewServerPool", path:"/viewserver_pool", isActive: true},
];

class ViewServerPool extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentServerPool: null,
            auto_scaling: false,
            activeTab: 0
        };
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
  
    componentDidMount(){
        this.props.getServerPools();
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.server_pools.length > 0){        	
            let currentServerPool = nextProps.server_pools.find(server_pool => server_pool.server_pool_id === this.props.match.params.id);
            this.setState({currentServerPool: currentServerPool});
        }
    }


    render(){
        const {currentServerPool} = this.state;
        return (
            <div className="profile-page"> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Pool</strong>
                                {currentServerPool ? <Link className="pull-right" to={{ pathname: `/update_server_pool/${currentServerPool.server_pool_id}`}}>
                                    <Button className = "reset-btn" size="sm" color="primary"> Edit Pool </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentServerPool?
                                                <Table >
                                                    <tbody>
                                                       <tr><td><h4>ID</h4></td><td>{currentServerPool.server_pool_id}</td></tr>
                                                       <tr><td><h4>Name</h4></td><td>{currentServerPool.server_pool_name}</td></tr>
                                                       <tr><td><h4>Servers</h4></td><td className="word-wrap">
                                                            <ReactJson src={currentServerPool.servers}
                                                                name={false}
                                                                collapsed={false}
                                                                sortKeys={true}
                                                                collapseStringsAfterLength={40}
                                                                enableClipboard={false}
                                                                displayDataTypes={false}
                                                            />
                                                       </td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                )}
            </div>
        );}
}

ViewServerPool.propTypes = {
    getServerPools: Proptypes.func.isRequired,
    server_pools: Proptypes.array,
    licenses: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        server_pools: state.server_pools.server_pools || [],
        licenses: state.system_info.licenses
    }),
dispatch => 
    ({
        getLicenses: () => dispatch(getLicenses()),
        getServerPools: () => dispatch(getServerPools()),
    }))(ViewServerPool);